import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { ListResource } from '../../../../components/ListResource/ListResource';
import { setRatingShowInfo } from '../utils/setRatingShowInfo';
import {
  createConditionalRatingColumns,
  createStandardRatingColumns
} from '../../../../utils/createRatingColumns';
import { toParticipantOption } from '../../../../utils/reviewParticipants';

const ListRatings = ({
  reviewActiveKey,
  pensioner,
  questionnaireType,
  setSupervisionRating,
  setReviewDrawerOpen,
  form,
  setShowReviewDrawer,
  setRefreshData,
  refreshData,
  setReviewData,
  reviewData,
  setEditReviewDrawer
}) => {
  const { t } = useTranslation();
  const userId = pensioner?.user?._id ?? pensioner?.user;

  const setExtraQuery = () => {
    if (reviewActiveKey === 'received_reviews') {
      return `received_reviews=${userId}`;
    }
    return `author.id=${userId}`;
  };
  useEffect(() => {
    setExtraQuery();
    setRefreshData(!refreshData);
  }, [reviewActiveKey]);

  useEffect(() => {
    if (Object.keys(reviewData).length) {
      setRatingShowInfo({
        setSupervisionRating,
        reviewData,
        reviewActiveKey,
        form,
        questionnaireType
      });
    }
  }, [reviewData]);

  // Nothing to list before the pensioner and its account are loaded: an
  // undefined id would reach the API as the string "undefined".
  if (!userId) return null;

  const setDataForCreateForm = () => {
    form.resetFields();
    setShowReviewDrawer(false);
    form.setFieldsValue({
      questionnaire_type: 'users:PENSIONER',
      author: { id: toParticipantOption(pensioner) }
    });
  };

  const columns = [
    ...createConditionalRatingColumns({ t, reviewActiveKey }),
    ...createStandardRatingColumns({
      t,
      setEditReviewDrawer,
      setShowReviewDrawer,
      setReviewData,
      setReviewDrawerOpen
    })
  ];

  return (
    <ListResource
      forceRefresh={refreshData}
      resourceName="ratings"
      columns={columns}
      extraQuery={setExtraQuery()}
      populate="author.id.user,receiver.id.user,"
      customActionColumn
      withPageHeader={false}
      withCreateButton={false}
      withCustomCreateButton={reviewActiveKey === 'left_reviews'}
      onDoubleClickAction={{
        action: (record) => {
          setEditReviewDrawer(false);
          setShowReviewDrawer(true);
          setReviewData(record);
          setReviewDrawerOpen(true);
        }
      }}
      customCreateButtonAction={() => {
        setShowReviewDrawer(false);
        setEditReviewDrawer(false);
        setReviewDrawerOpen(true);
        setDataForCreateForm();
      }}
    />
  );
};

export default ListRatings;

ListRatings.propTypes = {
  reviewActiveKey: PropTypes.string.isRequired,
  pensioner: PropTypes.shape({
    _id: PropTypes.string,
    user: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.shape({ _id: PropTypes.string })
    ])
  }).isRequired,
  setReviewDrawerOpen: PropTypes.func.isRequired,
  form: PropTypes.shape({
    setFieldsValue: PropTypes.func,
    resetFields: PropTypes.func
  }).isRequired,
  questionnaireType: PropTypes.string.isRequired,
  setSupervisionRating: PropTypes.func.isRequired,
  setShowReviewDrawer: PropTypes.func.isRequired,
  setRefreshData: PropTypes.func.isRequired,
  refreshData: PropTypes.bool.isRequired,
  setReviewData: PropTypes.func.isRequired,
  reviewData: PropTypes.shape({}),
  setEditReviewDrawer: PropTypes.func.isRequired
};

ListRatings.defaultProps = {
  reviewData: {}
};
